<pbc-sorter [config]="FormulareSorterConfig" [sorter]="formulare.sorter$ | async" (sorterChange)="formulare.sorter$.next($event)"></pbc-sorter>
